!((document, Drupal, $) => {
  'use strict';

  function searchFormChangeActions() {
    // Scope to the nav-branding region, not the form's generated ID: the
    // "--2" suffix moves between the mobile and desktop search blocks
    // depending on which one Drupal builds first.
    var $form = $('header .region--nav-branding--container form');
    var origForm = $form.serialize();
    var formSubmitButton = $form.find('.form-actions button');

    // Default submit button state for search form
    formSubmitButton.prop('disabled', true);

    $form.on('change input', function() {
      if ($form.serialize() !== origForm) {
        formSubmitButton.prop('disabled', false);
      } else {
        formSubmitButton.prop('disabled', true);
      }
    });
  }

  function formatTelField() {
    var phoneField = document.getElementsByClassName('input-tel')[0];
    if (phoneField) {
      phoneField.addEventListener('keyup', function() {
        var phoneValue = phoneField.value;
        var output;
        phoneValue = phoneValue.replace(/[^0-9]/g, '');
        var area = phoneValue.substr(0, 3);
        var pre = phoneValue.substr(3, 3);
        var tel = phoneValue.substr(6, 4);
        if (area.length < 3) {
          output = '(' + area;
        } else if (area.length === 3 && pre.length < 3) {
          output = '(' + area + ')' + ' ' + pre;
        } else if (area.length === 3 && pre.length === 3) {
          output = '(' + area + ')' + ' ' + pre + '-' + tel;
        }
        phoneField.value = output;
      }, {passive: true});
    }
  }

  Drupal.behaviors.autocompleteInputField = {
    // Get loading button to add/remove classes
    attach: function(context) {
      function handleInputAutocomplete(inputTarget, formFieldWrapper) {
        $.each(inputTarget, function() {
          var that = $(this);

          var submitButtonWrap = that
            .closest('form')
            .find('.submit-button-wrap');
          var formGroup = that.closest(formFieldWrapper);

          that.autocomplete({
            appendTo: formGroup
          });

          // Autocomplete search initiated.
          that.bind('autocompletesearch', function(event, ui) {
            submitButtonWrap
              .addClass('loading loading--autocomplete')
              .find('button')
              .attr('disabled', true);
          });

          // Autocomplete search opened suggestions after receiving results
          that.bind('autocompleteopen', function(event, ui) {
            submitButtonWrap
              .removeClass('loading loading--autocomplete')
              .find('button')
              .attr('disabled', false);
          });
        });
      }

      // Search page and search icon autocomplete.
      //
      // These used to be bound by element ID, one call per suffix Drupal
      // happened to generate (#edit-fulltext, --2, --3). The suffix depends on
      // how many fulltext inputs were built before this one, which differs per
      // page and shifts whenever a search block is rebuilt on its own, so bind
      // by input name and resolve the wrapper the suggestion list is appended
      // to from the input itself. On the search page that wrapper is
      // .form-field-col.fulltext; in the header search blocks it is
      // .form-item-fulltext.
      handleInputAutocomplete(
        $('input.form-autocomplete[name="fulltext"]'),
        '.form-field-col.fulltext, .form-item-fulltext'
      );
    }
  };

  function addLoadingMarkup(targetEl) {
    // Adds markup for loading show/hide
    const div = document.createElement('div');

    div.className = 'lds-ring';

    div.innerHTML = `
      <div></div><div></div><div></div><div></div>
    `;

    targetEl.appendChild(div);
  }

  // For input submit buttons
  function loadingStateMarkup() {
    const targetNodes = document.querySelectorAll('.submit-button-wrap');
    targetNodes.forEach((targetNode) => {
      // Add loading markup, will be hidden by default until loading state changes
      addLoadingMarkup(targetNode);
    });
  }

  loadingStateMarkup();

  searchFormChangeActions();
  formatTelField();
})(document, Drupal, jQuery);
